import React from "react";
import { FormattedNumber } from "react-intl";
import { useDispatch } from "react-redux";
import { setOfferFlexbooked } from "amadeusredux/lib/hotelSlice.js";
import { currencySymbol } from "../utils.js";
import { FaLongArrowAltDown, FaLongArrowAltUp } from "react-icons/fa";
import InfoPopupHover from "../components/InfoPopupHover.js";
import PriceChange from "../components/PriceChange.js";

export default function TourOperatorRoom(props) {
  let {
    allBoards,
    roomTypes,
    offer,
    travellerfactor,
    offsetTop,
    setFlexSelected,
  } = props;
  const dispatch = useDispatch();
  if (!Array.isArray(allBoards)) allBoards = [];
  if (!Array.isArray(roomTypes)) roomTypes = [];

  return (
    <>
      <div style={{ fontSize: "12pt", fontWeight: 600, display: "flex" }}>
        <div>{offer?.destination?.Name}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
        {offer?.TourOperator?.TourOperatorImage && (
          <img
            alt={offer?.TourOperator?.TourOperatorName}
            src={offer?.TourOperator?.TourOperatorImage}
          ></img>
        )}
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            minWidth: 100 / (allBoards.length + 1) - 1 + "%",
            width: 100 / (allBoards.length + 1) - 1 + "%",
            maxWidth: 100 / (allBoards.length + 1) - 1 + "%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            marginRight: "1%",
            padding: 2,
          }}
        ></div>
        {allBoards.map((bt) => {
          return (
            <div
              style={{
                padding: 2,
                marginRight: "1%",
                minWidth: 100 / (allBoards.length + 1) - 1 + "%",
                width: 100 / (allBoards.length + 1) - 1 + "%",
                maxWidth: 100 / (allBoards.length + 1) - 1 + "%",
                fontSize: "1.2em",
                overflow: "hidden",
                fontWeight: 600,
              }}
            >
              {bt.label}
            </div>
          );
        })}
      </div>
      {roomTypes.map((rt, idx) => {
        return (
          <div
            className="board"
            style={{
              backgroundColor: idx % 2 ? "white" : "#f3f0ed",
            }}
          >
            <div
              className="board1"
              style={{
                minWidth: 100 / (allBoards.length + 1) - 1 + "%",
                width: 100 / (allBoards.length + 1) - 1 + "%",
                maxWidth: 100 / (allBoards.length + 1) - 1 + "%",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
              title={rt.label}
            >
              {rt.label}
            </div>
            {allBoards.map((bt, i) => {
              let cheapest = rt.offers.find((e) => e.boardtype === bt.value);
              return (
                <div
                  className={i === allBoards.length - 1 ? "board2" : "board1"}
                  style={{
                    minWidth: 100 / (allBoards.length + 1) - 1 + "%",
                    display: "flex",
                  }}
                >
                  {" "}
                  {cheapest && <>ab&nbsp;</>}
                  {cheapest ? (
                    <span
                      className="price"
                      style={{
                        textDecoration:
                          cheapest.checked == -1 ? "line-through" : undefined,
                      }}
                      onClick={() => {
                        setFlexSelected(false);
                        dispatch(
                          setOfferFlexbooked({
                            offerId: cheapest.offerid,
                            flexbooked: false,
                          })
                        );
                        window.scrollTo(0, offsetTop);
                        props.setOfferId(cheapest.offerid);
                      }}
                    >
                      <PriceChange
                        price={cheapest.price}
                        checked={cheapest.checked}
                        cacheprice={cheapest.cacheprice}
                        travellerfactor={travellerfactor}
                        currencyCode={offer.PriceInfo.Price.CurrencyCode}
                      />
                      <FormattedNumber
                        value={cheapest.price * travellerfactor}
                        minimumFractionDigits={0}
                        maximumFractionDigits={0}
                      />
                      &nbsp;
                      {currencySymbol(offer.PriceInfo.Price.CurrencyCode)}
                    </span>
                  ) : (
                    <span></span>
                  )}
                  {cheapest && (
                    <>
                      {/*
                      &nbsp;&nbsp;&nbsp;(
                      {rt.offers.filter((e) => e.boardtype === bt.value).length}
                      )*/}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}
